import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"

export default function FieldEstimate_QuickFilterView(props: FieldQuickFilterViewProps) {

    const label = (props.value && props.value !== 'null')
        ? gd.utils.minutesHumanize(props.value)
        : 'Not set'

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            <div className="name">{label}</div>
        </div>
    )
}
